const config = {
  backendPort: 5000, // Port for the backend server
  frontendPort: 3000, // Port for the frontend server
};

export default config;